<template>
  <div>
    <canvas ref="barChart"></canvas>
  </div>
</template>

<script>
import { Chart } from 'chart.js/auto';
import { commissionLabel } from "./plugins";

export default {
  name: 'BarChart',
  props: {
    chartData: {
      type: Object,
      required: true
    },
    labelColors: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        layout: {
          padding: {
            top: 35
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: 'white'
            },
            border: {
              display: false
            }
          },
          y: {
            display: false
          }
        },
        events: [], // Disable all event listeners
        elements: {
          point: {
            hoverRadius: 0 // Disable hover effect on points (if applicable)
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    chartData: 'renderChart',
    labelColors: 'renderChart'
  },
  methods: {
    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart(this.$refs.barChart, {
        type: 'bar',
        data: this.chartData,
        options: this.chartOptions,
        plugins: [commissionLabel(this.labelColors, this.type)]
      });
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>